export default __webpack_public_path__ + "static/media/pantelis.b4750622.jpg";